<template>
  <zm-button data-testid="checkout-button-477" :data-url='targetUrl' size='large' round type='primary' @click='goToHDPage'> {{ $t('billing.success.get_started') }}</zm-button>
</template>
<script>
import { translateToEn } from '@/plugins/i18n';
import { navigateParentWindowTo, sendLoginMessageToClient } from '@/utils/modal-utils.js';
import modalMixin from '@/views/modal/modal-mx.js';
import { generateGAbizInfo } from '@/views/checkout/utils';
import { getEmailCTAsTrackingUrl, UTM_CONTENT_CODE } from '@/views/succezz/utils/email-ctas-tracking';
import { isIAPRedirectUser, redirectToClientProfilePage } from '@/utils/iap';

export default {
  mixins: [modalMixin],
  data() {
    return {
      jumpUrl: '/myhome',
    }
  },
  computed: {
    targetUrl() {
      return getEmailCTAsTrackingUrl(this.jumpUrl, { utmContent: UTM_CONTENT_CODE.getStarted });
    }
  },
  methods: {
    goToHDPage() {
      this.$tracking.buyInteractionWithBizInfo('purchase confirmation', translateToEn('billing.success.get_started'),...generateGAbizInfo());
      if (this.isFreeTrialInClientModal) {
        // send login message to client
        sendLoginMessageToClient();
      } else if (isIAPRedirectUser) {
        redirectToClientProfilePage()
      } else if (this.$context.is.modal) {
        navigateParentWindowTo(this.jumpUrl);
      } else {
        window.location.href = this.jumpUrl;
      }
    },
  },
}
</script>
